import React from 'react'
import Error from '@mortgage-pos/ui/pages/Error'
import incense from '@mortgage-pos/ui/incense'
import { ErrorBoundary } from 'react-error-boundary'
import newRelic from '@mortgage-pos/ui/services/newRelic'
import { useStoreState } from '@mortgage-pos/ui/store'

const CustomErrorBoundary: React.FC<{
  children: React.ReactNode
  onError?: (error: Error, info: { componentStack: string }) => void
}> = ({ children, onError }) => {
  const { applicationId } = useStoreState((state) => state.application)
  const { mergedAnswers } = useStoreState((state) => state.answers)
  const { active } = useStoreState((state) => state.questionnaire)

  const handleError = React.useCallback(
    (error: Error, info: { componentStack: string }) => {
      incense(error)
        .details({
          name: 'ErrorBoundary',
          message: 'Error boundary was hit',
        })
        .safe({ applicationId })
        .sensitive({ info, page: active.name, mergedAnswers })
        .error()

      newRelic.increment('error_boundary', [
        { key: 'applicationId', value: String(applicationId) },
        { key: 'page', value: active.name },
      ])
    },
    [applicationId, mergedAnswers, active]
  )

  return (
    <ErrorBoundary FallbackComponent={Error} onError={handleError}>
      {children}
    </ErrorBoundary>
  )
}

export default CustomErrorBoundary
